// useLayoutEffect in the browser, useEffect under SSR (where neither runs), so a server render never warns.

import { useEffect, useLayoutEffect } from "react";

export const useIsoLayoutEffect = typeof window !== "undefined" && typeof document !== "undefined" ? useLayoutEffect : useEffect;
